// In front of the classic signup's completion pages (/actor/pro-completed after
// the membership checkout, /actor/upgrade-completed after upgrade-to-Pro): a
// purchase that started in the submission flow goes back to step 4; any other
// visitor gets the page exactly as before (docs/30 §6).
//
// And in front of the classic upgrade pages an actor with no trial goes through
// (docs/35 S4): their events, only for a visit from the flow. Nothing inside
// the classic pages changes, and a classic visitor sends none of them.

import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { flowReturnSearch } from "./membershipPaywall";
import { trackSubmissionEvent } from "../analytics";

const fromFlow = (props: any): boolean => flowReturnSearch(props.location ? props.location.search : "") !== null;

/** Once per visit from the flow: the page's event. */
const useFlowEvent = (props: any, event: string | undefined, eventProps?: object) => {
  const flow = fromFlow(props);
  useEffect(() => {
    if (flow && event) trackSubmissionEvent(event, eventProps || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const withSubmissionReturn = (Component: React.ComponentType<any>, paidEvent?: string) => {
  const Gate: React.FC<any> = (props) => {
    useFlowEvent(props, paidEvent);
    const search = flowReturnSearch(props.location ? props.location.search : "");
    if (search !== null) return <Redirect to={`/submission/flow/step/4${search}`} />;
    return <Component {...props} />;
  };
  Gate.displayName = `withSubmissionReturn(${Component.displayName || Component.name || "Page"})`;
  return Gate;
};

export const withSubmissionEvent = (Component: React.ComponentType<any>, event: string, eventProps?: object) => {
  const Tracked: React.FC<any> = (props) => {
    useFlowEvent(props, event, eventProps);
    return <Component {...props} />;
  };
  Tracked.displayName = `withSubmissionEvent(${Component.displayName || Component.name || "Page"})`;
  return Tracked;
};

/** For the one guarded line inside a classic page: the event, only when the visit is from the flow. */
export const trackFromFlow = (search: string, event: string, eventProps?: object) => {
  if (flowReturnSearch(search || "") !== null) trackSubmissionEvent(event, eventProps || {});
};
